import Typography from '@mui/material/Typography';
import { ComponentPropsWithoutRef } from 'react';

type ComplianceFormFieldLegendProps = ComponentPropsWithoutRef<
  typeof Typography
>;

const complianceFormFieldLegendStyles = {
  legend: {
    color: '#777777',
  },
} as const;

export function ComplianceFormFieldLegend({
  children,
  sx,
  ...props
}: ComplianceFormFieldLegendProps) {
  return (
    <Typography
      variant="body1"
      sx={{
        ...complianceFormFieldLegendStyles.legend,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
}
